import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { GoogleOAuthProvider } from "@react-oauth/google";
import 'katex/dist/katex.min.css';
import { GlobalWorkerOptions } from 'pdfjs-dist';

// Set the workerSrc globally for pdf.js
GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.7.0/pdf.worker.min.js';




import NavigationBar from "./components/Navbar";
import "./Navbar.css";
import Home from "./pages/Home";
import Login from "./pages/Login";
import About from "./pages/About";
import FAQ from "./pages/FAQ";
import Courses from "./pages/Courses";
import PracticeTest from "./pages/PracticeTest";
import Products from "./pages/Products";
import Cart from "./pages/Cart";
import Profile from "./pages/Profile";
import TestPage from "./pages/TestPage";
import CoursePage from "./pages/CoursePage";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import QuestionBankPage from "./pages/QuestionBankPage";
import QuestionBank from "./pages/QuestionBank";


const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const API_URL = process.env.API_BASE_URL;

function App() {
  return (
    <HelmetProvider>
      <GoogleOAuthProvider clientId={CLIENT_ID}>
        <Router>
          {/* 🔹 Navigation Bar (Excluded from TestPage) */}
          <Routes>
            <Route path="/test/:testId" element={<TestPage />} />
            <Route path="/course/:courseId" element={<CoursePage />} />
            <Route path="/practicequestionsPage/:bankId" element={<QuestionBankPage />} />
            
            <Route
              path="/*"
              element={
                <>
                  <NavigationBar />
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/faq" element={<FAQ />} />
                    <Route path="/courses" element={<Courses />} />
                    <Route path="/practice-test" element={<PracticeTest />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/cart" element={<Cart />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/practicequestions" element={<QuestionBank />} />

                  </Routes>
                </>
              }
            />
          </Routes>
        </Router>
      </GoogleOAuthProvider>
    </HelmetProvider>
    
  );
}

export default App;
